<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="displayValue"
        v-bind="attrs"
        v-on="on"
        :style="{ width: inputWidth }"
        dense
        hide-details
        readonly
      ></v-text-field>
    </template>
    <v-card :style="{ width: menuWidth }">
      <v-card-text>
        <v-date-picker
          v-model="internalDate"
          color="blue"
          full-width
          locale="zh-TW"
        ></v-date-picker>
        <v-time-picker
          v-model="internalTime"
          color="blue"
          format="24hr"
          full-width
        ></v-time-picker>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- 清除 -->
        <v-btn
          class="
            font-weight-bold
            text-capitalize
            btn-ls btn-default
            bg-gradient-default
            py-3
            px-6
            mx-2
          "
          @click="clearDateTime"
          >清除</v-btn
        >
        <v-btn
          class="
            font-weight-bold
            text-capitalize
            btn-ls btn-secondary
            bg-gradient-light
            py-3
            px-6
            mx-2
          "
          @click="cancel"
          >取消</v-btn
        >
        <v-btn
          class="
            font-weight-bold
            text-capitalize
            ms-auto
            btn-primary
            bg-gradient-primary
            py-3
            px-6
            ms-3
          "
          @click="confirm"
          >確定</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "DateTimePicker",
  props: {
    value: {
      type: String,
      default: null,
    },
    date: {
      type: String,
      default: null,
    },
    time: {
      type: String,
      default: null,
    },
    inputWidth: {
      type: String,
      default: "100%",
    },
    menuWidth: {
      type: String,
      default: "320px",
    },
  },
  data() {
    return {
      menu: false,
      internalDate: null,
      internalTime: null,
    };
  },
  computed: {
    displayValue() {
      return this.value;
    },
  },
  watch: {
    date: {
      handler(val) {
        this.internalDate = val;
      },
      immediate: true,
    },
    time: {
      handler(val) {
        this.internalTime = val;
      },
      immediate: true,
    },
    menu(val) {
      if (val) {
        // When menu opens, sync internal values with props
        this.internalDate = this.date;
        this.internalTime = this.time;
      }
    },
  },
  methods: {
    clearDateTime() {
      this.internalDate = null;
      this.internalTime = null;
      this.$emit("update:date", null);
      this.$emit("update:time", null);
    },
    cancel() {
      this.menu = false;
      // Reset to original values
      this.internalDate = this.date;
      this.internalTime = this.time;
    },
    confirm() {
      this.$emit("update:date", this.internalDate);
      this.$emit("update:time", this.internalTime);
      this.$emit("confirm");
      this.menu = false;
    },
  },
};
</script>
